import * as THREE from 'three'
import Experience from '../Experience.js'

import gsap from 'gsap'

export default class LoadingBar
{
    constructor()
    {
        this.experience = new Experience()
        this.resources = this.experience.resources
        this.debug = this.experience.debug
        this.scene = this.experience.scene
        this.world = this.experience.world
        this.time = this.experience.time

        this.setLoadingBar()
    }

    setLoadingBar()
    { 

        const overlayGeometry = new THREE.PlaneGeometry(2, 2, 1, 1)
        const overlayMaterial = new THREE.ShaderMaterial({
            // wireframe: true,
            transparent: true,
            uniforms:
            {
                uAlpha: { value: 1 }
            },
            vertexShader: `
                void main()
                {
                    gl_Position = vec4(position, 1.0);
                }
            `,
            fragmentShader: `
                uniform float uAlpha;

                void main()
                {
                    gl_FragColor = vec4(0.0, 0.0, 0.0, uAlpha);
                }
            `
        })
        this.overlay = new THREE.Mesh(overlayGeometry, overlayMaterial)
        this.scene.add(this.overlay)

        this.loadingBarElement = document.querySelector('.loading-bar')

        this.resources.on('groupEnd', (_group) => 
        {
            // Wait a little
            window.setTimeout(() =>
            {
                // Animate overlay
                gsap.to(overlayMaterial.uniforms.uAlpha, { duration: 3, value: 0, delay: 1 })

                // Update loadingBarElement
                this.loadingBarElement.classList.add('ended')
                this.loadingBarElement.style.transform = ''
            }, 500)

            // window.setTimeout(() =>
            // {
            //     sceneReady = true
            // }, 2000)
        })

        this.resources.on('progress', (current) =>
        {
            // Calculate the progress and update the loadingBarElement
            const progressRatio = current.loaded / current.toLoad
            this.loadingBarElement.style.transform = `scaleX(${progressRatio})`
        })
    }

    update()
    {
    }
}